import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { RobotCorpse } from "./robotCorpse";

export class CaveRobotCorpse extends RobotCorpse {
	static key = "CaveRobotCorpse";
	constructor(xy: XY) {
		super(xy);
	}

	override getRepairableMobKey(): string | null {
		return "CaveRobot";
	}

	static deserialize(data: any): CaveRobotCorpse {
		const c = new CaveRobotCorpse(deserializeXY(data.xy));
		c.restoreBaseFields(data);
		return c;
	}
}
